import axios from "axios";

export const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + "/v2",
  // baseURL: "https://api-live.skills.id/v2",
  // baseURL: "https://d186-103-153-229-210.ngrok-free.app/v2",
});

export const fileBaseUrl = process.env.REACT_APP_BASE_URL + "/file/";
